import { Navigate } from 'react-router-dom';
import { useAvailableReports } from '../../hooks/Reports/useAvailableReports';
import Loader from '../../components/Loader';
import { ALWAYS_PRESENT_REPORTS_MAP } from '../../constants/Reports';

const ReportsPermissionRoute = ({ children, reportId }) => {
  const { availableReportsIds, isReportsLoading } = useAvailableReports();

  if (isReportsLoading === null || isReportsLoading === true) return <Loader />;

  if (
    !availableReportsIds.includes(reportId) &&
    !ALWAYS_PRESENT_REPORTS_MAP.includes(reportId)
  )
    return <Navigate to={'/firehouse/404'} />;

  return children;
};

export default ReportsPermissionRoute;
